<template>
    <div class="position-relative">
        <div class="title-section">
            <img src="@/assets/images/sketch_new_consultant.png" class="text-center">
        </div>
        <validation-observer #default="{ invalid }" ref="facturareSingle">
            <span class="display-none">{{ invalid }}</span>
            <b-form>
                <div class="licenta-content">
                    <div class="licenta-inputs">
                        <validation-provider
                            #default="{ errors }"
                            rules="required|numeric|min_value:2|max_value:9999"
                            name="licențe"
                        >
                            <b-form-group id="input-name" class="form-label position-relative">
                                <label>Alege numărul de licențe</label>
                                <b-form-input
                                    id="v-step-0"
                                    v-model="form.licenses"
                                    :state="errors.length > 0 ? false : null"
                                    type="number"
                                    placeholder="0"
                                    class="w-100"
                                    @keyup="maxCharLimit()"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>

                        <p class="title-left">Cost unitar:</p>
                        <div class="price">
                            <h3><sub>Lei</sub>{{ getUnitPrice() }}</h3>
                            <p>(fără TVA)</p>
                        </div>
                        <p class="title-left">Cost total:</p>
                        <div id="v-step-1" class="price green-price">
                            <h3 v-if="!discount"><sub>Lei</sub>{{ calculateTotal() }}</h3>
                            <h3 v-if="discount && form.licenses > 1"><del style="font-size: 33px; color: #545a6f!important; opacity: 0.1" ><sub style="color: #545a6f!important;">Lei</sub>{{ calculateTotal() }}</del>&nbsp; <sub>Lei</sub>{{ calculateTotal() - discount }}</h3>
                            <p>(fără TVA)</p>
                        </div>
                    </div>
                    <div class="licenta-infos">
                        <div class="info" :class="form.licenses > 1 && form.licenses < 11 ? 'green-price' : ''">
                            <p class="price-small">1400 Lei*</p>
                            <p class="price-small-info">2-10 proiecte</p>
                        </div>
                        <div class="info" :class="form.licenses > 10 && form.licenses < 31 ? 'green-price' : ''">
                            <p class="price-small">950 Lei*</p>
                            <p class="price-small-info">11-30 proiecte</p>
                        </div>
                        <div class="info" :class="form.licenses > 30 ? 'green-price' : ''">
                            <p class="price-small">700 Lei*</p>
                            <p class="price-small-info">peste 30 proiecte</p>
                        </div>
                    </div>
                </div>
                <p class="dark-gray"><strong>{{ form.licenses > 1 ? form.licenses : 0 }}</strong> licențe utilizare / <strong>{{ form.licenses > 1 ? form.licenses : 0 }}</strong> proiecte / <strong>{{ form.licenses > 1 ? form.licenses : 0 }}</strong> companii</p>
                <div class="button-list">
                    <div class="pink-gradient-button" :class="invalid ? 'pointer-none' : ''" @click="handleClick(invalid)">Continuă către facturare</div>
                    <ModalLicenta :licenseModal="licenseModal" :statistics="statistics" @hideTempModal="licenseModal = false" @continueToInvoice="$emit('increaseStep')"></ModalLicenta>
                    <div class="black-gradient-button" @click="$emit('switchSelection')">Comandă o singură licență</div>
                </div>
                <p class="small-info-text">* prețuri fără TVA</p>
            </b-form>
        </validation-observer>
    </div>

</template>

<script>
    import {BForm, BFormGroup, BFormInput} from 'bootstrap-vue';
    import ModalLicenta from './ModalLicenta'
    import {ValidationProvider, ValidationObserver} from 'vee-validate'
    /*import axios from '@/helpers/axios'
import api from '@/helpers/api'*/
    require('@/helpers/validations/validations')
    export default {
        components: {
            BForm,
            BFormGroup,
            BFormInput,
            ModalLicenta,
            ValidationProvider,
            ValidationObserver
        },
        props: {
            discount: null,
            licenseModalShowed: null,
        },
        data() {
            return {
                maxLength: 9999,
                form: {
                    licenses: ''
                },
                licenseModal: false,
            }
        },
        computed: {
            statistics() {
                return this.$store.getters['m3Sketch/indicators']
            },
        },
        mounted() {
            this.showLicenseModal()
        },
        watch: {
            'form.licenses': {
                handler: function (){
                    this.$emit('licensesChanged', this.form.licenses)
                    this.handleClick()
                }
            }
        },
        methods: {
            getUnitPrice() {
                if(!this.form.licenses || this.form.licenses < 11) {
                    return 1400
                } else if(this.form.licenses > 10 && this.form.licenses < 31){
                    return 950
                } else if(this.form.licenses > 30){
                    return 700
                }
            },

            calculateTotal() {
                if(! this.form.licenses || this.form.licenses < 2) {
                    return 0;
                }

                return (this.getUnitPrice() * this.form.licenses);
            },

            handleClick(invalid) {
                console.log('invalid', invalid);
                if(invalid){
                    this.$toast.error('Completează mai întâi numărul licențelor solicitate.')
                } else if(!invalid && this.form.licenses >= 2) {
                    this.$emit('increaseStep', this.form.licenses)
                }
            },
            showLicenseModal() {
                if(!this.licenseModalShowed) {
                    this.licenseModal = true
                    this.$emit('licenseModalShowed')
                }
            },
            maxCharLimit(){
                if(this.form.licenses > 9999) {
                    this.form.licenses = 9999
                }
            }
        }
    }
</script>

<style scoped>
.position-relative{
    position: relative;
}
.small-info-text{
    position: absolute;
    bottom: -30px;
    left: -10px;
    opacity: 0.5;
    font-size: 13px;
    color: #000000;
}
.text-danger{
    position: absolute;
    right: 0;
    bottom: -10px;
}
.title-section img{
    width: 100%;
    object-fit: none;
    max-height: 50px;
    margin-top: 30px;
    margin-bottom: 45px;
}
.licenta-content{
    display: flex;
    padding: 0 40px;
    justify-content: space-between;
}
.licenta-infos, .licenta-inputs{
    max-width: 49%;
    width: 100%;
}
form{
    margin-bottom: 15px;
}
.form-group{
    margin-bottom: 0;
    margin-top: 10px;
}
.form-group >>> label{
    font-size: 17px;
    color: #969db6;
    font-weight: 600;
    margin-bottom: 5px;
}
.form-group >>> input{
    font-size: 17px;
    color: #969db6;
    font-weight: 600;
    margin-bottom: 10px;
    max-height: 30px;
    text-align: center;
}
.form-group >>> input::placeholder{
    opacity: 0.3;
}
.pointer-none{
    opacity: 0.4;
}
.price{
    width: 100%;
    text-align: right;
    margin: 0 0 0 auto;
}
.price sub{
    font-size: 35px;
    bottom: 0;
    font-weight: 700;
}
.price h3{
    font-size: 55px;
    color: #545a6f;
    margin: 0;
    line-height: 1;
    font-weight: 700;
}
.price p{
    font-size: 12px;
    text-align: right;
}
.title-left{
    font-size: 17px;
    color: #969db6;
    font-weight: 600;
    margin-bottom: 5px;
}
.green-price >>> *{
    color: #02c199 !important;
}
.dark-gray{
    color: #545a6f;
    font-size: 21px;
    text-align: center;
    margin-top: 40px;
    margin-bottom: 25px;
}
.licenta-infos{
    background: #f2f3f5;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 15px;
    justify-content: center;
}
.info:not(:last-child){
    margin-bottom: 25px;
}
.price-small{
    font-size: 20px;
    color: #545a6f;
    font-weight: 800;
    text-align: center;
    margin-bottom: 0;
    line-height: 1;
}
.price-small-info{
    font-size: 15px;
}
.button-list{
    display: flex;
    justify-content: space-evenly;
}
.pink-gradient-button{
    background: linear-gradient(to bottom, #e6ad8a, #a669af);
    padding: 5px;
    text-align: center;
    margin: 15px 0;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 240px;
    font-size: 15px;
    font-weight: 700;
    transition: 0.4s;
    color: #fff;
    cursor: pointer;
}
.black-gradient-button{
    background: linear-gradient(to bottom, #5a5a5a, #686868);
    padding: 5px;
    text-align: center;
    margin: 15px 0;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 240px;
    font-size: 15px;
    font-weight: 700;
    transition: 0.4s;
    color: #fff;
    cursor: pointer;
}
</style>
